import React from "react";
import { useStep } from "react-hooks-helper";
import BookingDetails from "../components/steps/BookingDetails";
import SelectEmbassy from "../components/steps/SelectEmbassy";
import AttestationService from "../components/steps/AttestationService";
import useForm from "../components/utilities/useForm";
import { getStateSchema, getValidatorSchema } from "../components/utilities/utilities"
import PaymentSummary from "./PaymentSummary";
import NotAvailableEmbassy from "./NotAvailableEmbassy";
import { useTranslation } from 'react-i18next';
import PaymentScheduled from "../components/steps/PaymentScheduled";




const steps = [
    { id: "select-embassy"},
    { id: "attestation-service"},
    { id: "address-details"},
    { id: "contact-verification"},
    { id: "good-enter-details"},
    { id: "shipping-sender"},
    { id: "shipping-receiver"},
    { id: "shipping-review"},
    { id: "good-booking-success"},
    { id: "receiver-details"},
    { id: "review-details"},
    { id: "payment-summary"},
    { id: "submit"},
    { id: "payment-scheduled"},
    {id:'embassy-not-available'}
]
function CreateEmbassyBooking() {

    
    const { t, i18n } = useTranslation();
    const stateSchema = getStateSchema();
    const stateValidatorSchema = getValidatorSchema();
    const { values, errors, dirty, handleOnChange,newHandleOnChange,handleFileChange, setData, resetFormToInitial} = useForm(stateSchema, stateValidatorSchema);
    const {step, navigation} = useStep({
        steps,
        initialStep: 0
    }); 
    const setLocale = (locale) => {
        document.body.setAttribute("lang", locale);
        document.body.setAttribute("dir", locale==="ar"? "rtl" : "ltr");
    } 
    
    const changeLanguageHandler = () => {
        const language = i18n.language;
        const selectedLocale = language === "en" ? "ar": "en"
        i18n.changeLanguage(selectedLocale);
        setData({"name": "locale", "value": selectedLocale});
        setLocale(selectedLocale);
    }
    const changeLanguageArabic = () => {
   
        i18n.changeLanguage('ar');
        setData({"name": "locale", "value": 'ar'});
        setLocale('ar');
    }

    const props = {values, errors, dirty,handleFileChange, handleOnChange, newHandleOnChange,setData, resetFormToInitial, useForm, navigation, step, t, i18n, changeLanguageHandler,changeLanguageArabic};

    if(i18n.language=='en')
      document.title = 'Consulates & Embassies | EMX';
    
    if(i18n.language=='ar')
        document.title = 'السفارات والقنصليات | إي أم أكس';

    switch(step.id){
        case 'select-embassy':
           return <SelectEmbassy { ...props }/>;              
        case 'attestation-service':
            return <AttestationService { ...props }/>; 
        case 'address-details':
            return <BookingDetails {...props} />;
        case 'receiver-details':
            return <BookingDetails {...props} />;
        case 'contact-verification':
            return <BookingDetails { ...props } />;
        case 'good-enter-details':
            return <BookingDetails { ...props } />;
        case 'shipping-sender':
            return <BookingDetails { ...props } />;
        case 'shipping-receiver':
            return <BookingDetails { ...props } />;
        case 'shipping-review':
            return <BookingDetails { ...props } />;
        case 'good-booking-success':
            return <BookingDetails { ...props } />;
        case 'review-details':
            return <BookingDetails { ...props } />;
        case 'payment-summary':
             return <PaymentSummary {...props} />;
        case 'embassy-not-available':
             return <NotAvailableEmbassy {...props} />;
        case 'payment-scheduled':
             return <PaymentScheduled {...props} />;
        default:
            return <SelectEmbassy { ...props }/>; 
    }    
}
  
export default CreateEmbassyBooking;
  